import React from 'react';
import {
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CNavItem,
  CNavTitle,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilSpeedometer, cilUser, cilPeople, cilLayers, cilCreditCard, cilLifeRing } from '@coreui/icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Sidebar = ({ sidebarShow, setSidebarShow }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Check if current user is super admin
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const isSuperAdmin = userInfo.is_super_admin;

  const isActive = (path) => location.pathname === path;

  const handleItemClick = () => {
    if (window.innerWidth < 768) {
      setSidebarShow(false);
    }
  };

  const handleHelpSupportClick = () => {
    // Redirect to external website
    window.open('https://geowgs84.com', '_blank');
    handleItemClick();
  };

  // Handle Clients navigation
  const handleClientsClick = (e) => {
    e.preventDefault();
    if (isSuperAdmin) {
      navigate('/super-admin/clients');
    } else {
      navigate('/clients');
    }
    handleItemClick();
  };

  // Handle Subscriptions navigation
  const handleSubscriptionsClick = (e) => {
    e.preventDefault();
    if (isSuperAdmin) {
      navigate('/super-admin/orders');
    } else {
      navigate('/subscriptions');
    }
    handleItemClick();
  };

  // Handle Dashboard navigation
  const handleDashboardClick = (e) => {
    e.preventDefault();
    if (isSuperAdmin) {
      navigate('/dashboard');
    } else {
      navigate('/dashboard');
    }
    handleItemClick();
  };

  // Get the active class for a given path
  const getActiveClass = (paths) => {
    return paths.includes(location.pathname) ? 'active' : '';
  };

  return (
    <CSidebar className="border-end h-100 glass-sidebar">
      <CSidebarBrand 
        className="d-none d-md-flex p-3" 
        style={{ 
          backgroundColor: 'white',
          borderBottom: '1px solid #dee2e6'
        }}
      >
        <img 
          src="/Lizardtech_GeoWGS84_Logo_H_T.png" 
          alt="LizardTech GeoWGS84 Logo" 
          style={{ 
            height: '55px', 
            width: 'auto',
            maxWidth: '180px',
            objectFit: 'contain'
          }}
        />
      </CSidebarBrand>
      
      <CSidebarNav>
        <CNavTitle>Navigation</CNavTitle>
        
        <CNavItem>
          <Link 
            to="/dashboard" 
            className={`nav-link ${getActiveClass(['/dashboard', '/super-admin/dashboard'])}`}
            onClick={handleDashboardClick}
          >
            <CIcon customClassName="nav-icon" icon={cilSpeedometer} />
            Dashboard
          </Link>
        </CNavItem>
        
        <CNavItem>
          <button 
            className={`nav-link border-0 bg-transparent w-100 text-start ${getActiveClass(['/clients', '/super-admin/clients'])}`}
            onClick={handleClientsClick}
            style={{ cursor: 'pointer' }}
          >
            <CIcon customClassName="nav-icon" icon={cilPeople} />
            {isSuperAdmin ? 'All Clients' : 'My Clients'}
          </button>
        </CNavItem>
        
        <CNavItem>
          <button 
            className={`nav-link border-0 bg-transparent w-100 text-start ${getActiveClass(['/software-products', '/super-admin/software-products'])}`}
            onClick={() => {
              if (isSuperAdmin) {
                navigate('/super-admin/software-products');
              } else {
                navigate('/software-products');
              }
              handleItemClick();
            }}
            style={{ cursor: 'pointer' }}
          >
            <CIcon customClassName="nav-icon" icon={cilLayers} />
            Software Products
          </button>
        </CNavItem>
        
        <CNavItem>
          <button 
            className={`nav-link border-0 bg-transparent w-100 text-start ${getActiveClass(['/subscriptions', '/super-admin/orders'])}`}
            onClick={handleSubscriptionsClick}
            style={{ cursor: 'pointer' }}
          >
            <CIcon customClassName="nav-icon" icon={cilCreditCard} />
            {isSuperAdmin ? 'All Orders' : 'Subscriptions'}
          </button>
        </CNavItem>
        
        <CNavItem>
          <Link 
            to="/profile" 
            className={`nav-link ${isActive('/profile') ? 'active' : ''}`}
            onClick={handleItemClick}
          >
            <CIcon customClassName="nav-icon" icon={cilUser} />
            Profile
          </Link>
        </CNavItem>

        {/* Help and Support Section */}
        <div className="mt-auto">
          <CNavTitle>Support</CNavTitle>
          <CNavItem>
            <button 
              className="nav-link border-0 bg-transparent w-100 text-start"
              onClick={handleHelpSupportClick}
              style={{ cursor: 'pointer' }}
            >
              <CIcon customClassName="nav-icon" icon={cilLifeRing} />
              Help & Support
            </button>
          </CNavItem>
        </div>
      </CSidebarNav>
    </CSidebar>
  );
};

export default Sidebar;